import { Tab, Tabs, Box, Stack, Typography, SxProps } from "@mui/material";
import AdminPanelOrgTable from "../../../components/super-admin/systemManagement/orgTab/SAOrgTable";
import AdminPanelUserTable from "../../../components/super-admin/systemManagement/userTab/SAUserTable";
import { useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import Loader from "../../../components/super-admin/common/Loader";
import { useOrgListSA, useUserListSA } from "../../../tanstackQuery/queries/superAdmin/org";

const TOTAL_ORG_USER_STYLES: SxProps = {
  backgroundColor: "#D9D9D9",
  padding: "5px 30px",
  borderRadius: "4px",
  fontWeight: "bold",
  fontSize: "16px",
};

const SuperAdminView = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { keycloak } = useKeycloak();


  const { data: orgData, isLoading: isOrgLoading } = useOrgListSA(
     { accessToken: keycloak?.token },
     {},
     { enabled: !!keycloak?.token }
  );
  const { data: userData, isLoading: isUserLoading } = useUserListSA(
     { accessToken: keycloak?.token },
     {},
     { enabled: !!keycloak?.token }
  );

  const handleTabChange = (event, newIndex) => {
    setActiveTab(newIndex);
  };

  if (isOrgLoading && isUserLoading) {
    return <Loader />;
  }

  return (
    <Box>
      <Box>
        <Stack direction="row" spacing={6} mb={1}>
          <Typography
            sx={{
              fontSize: "25.63px",
              fontWeight: 700,
              lineHeight: "30.76px",
            }}
          >
            Super Admin : Org/User Detail View
          </Typography>
          <Box sx={TOTAL_ORG_USER_STYLES}>
            Organization: {orgData?.length || 0}
          </Box>
          <Box sx={TOTAL_ORG_USER_STYLES}>
            User: {userData?.length || 0}
          </Box>
        </Stack>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab value={0} label="Organizations" />
          <Tab value={1} label="Users" />
        </Tabs>
      </Box>
      {activeTab === 0 && (
        <AdminPanelOrgTable data={orgData ?? []} />
      )}
      {activeTab === 1 && (
        <AdminPanelUserTable data={userData ?? []} />
      )}
    </Box>
  );
};

export default SuperAdminView;
